/**
 * Mock data factories for booking endpoints
 */

// Constants for random ID generation
const RANDOM_ID_BASE = 36;
const RANDOM_ID_START = 2;
const RANDOM_ID_LENGTH = 9;
const RANDOM_REF_LENGTH = 6;


/**
 * Generate a random ID with a prefix
 *
 * @param prefix - ID prefix
 * @returns Random ID
 */
export function generateId(prefix: string): string {
  return `${prefix}-${Math.random().toString(RANDOM_ID_BASE)
    .substring(RANDOM_ID_START, RANDOM_ID_LENGTH)}`;
}

/**
 * Generate a random reference code
 *
 * @param prefix - Reference prefix
 * @returns Random reference code
 */
export function generateReference(prefix: string): string {
  return `${prefix}-${Math.random().toString(RANDOM_ID_BASE)
    .substring(RANDOM_ID_START, RANDOM_REF_LENGTH)
    .toUpperCase()}`;
}

/**
 * Generate a random date
 *
 * @param minutesOffset - Number of minutes to add to the current date
 * @returns Random date string in ISO format (UTC)
 */
export function generateDate(minutesOffset: number = 0): string {
  const date = new Date(Date.now() + minutesOffset * 60 * 1000);
  return date.toISOString();
}

/**
 * Generate a date offset from today by days
 *
 * @param daysOffset - Number of days to add/subtract from today
 * @returns ISO timestamp string
 */
export function generateDateWithDayOffset(daysOffset: number = 0): string {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  return date.toISOString();
}